import { render, staticRenderFns } from "./JobMessageListTab.vue?vue&type=template&id=46fde221&"
import script from "./JobMessageListTab.vue?vue&type=script&lang=js&"
export * from "./JobMessageListTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports